"use client";
import { motion } from "framer-motion";
import { FaCode, FaChartLine, FaLightbulb, FaUsers } from "react-icons/fa";

const aboutCardsData = [
  {
    id: 1,
    icon: <FaLightbulb />,
    title: "Our Philosophy",
    description:
      "We believe technology should solve real problems. Our approach combines lean methodology with robust engineering to create meaningful impact.",
  },
  {
    id: 2,
    icon: <FaCode />,
    title: "Technical Expertise",
    description:
      "With deep knowledge across modern stacks, we architect solutions that are scalable, maintainable, and future-proof.",
  },
  {
    id: 3,
    icon: <FaChartLine />,
    title: "Data-Driven Approach",
    description:
      "We measure everything. Our decisions are guided by analytics to ensure we're delivering maximum value at every step.",
  },
  {
    id: 4,
    icon: <FaUsers />,
    title: "Collaborative Team",
    description:
      "Our cross-functional teams work as an extension of your organization, aligning with your goals and culture.",
  },
];

export default function AboutSection() {
  return (
    <section id="about-us" className="about-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <h2 className="section-title">
            <span style={{ color: "black" }}>Crafting</span> Digital Excellence
          </h2>
          <p className="section-subtitle">
            We blend technical expertise with creative vision to deliver
            solutions that matter
          </p>
        </motion.div>

        <motion.div
          className="about-cards"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ staggerChildren: 0.1, delayChildren: 0.3 }}
          viewport={{ once: true, margin: "-50px" }}
        >
          {aboutCardsData.map(({ id, icon, title, description }, index) => (
            <motion.div
              key={id}
              className="about-card"
              whileHover={{ y: -5 }}
              transition={{ type: "spring", stiffness: 300 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: { delay: index * 0.1 },
              }}
            >
              <div className="card-icon-wrapper">{icon}</div>
              <h3>{title}</h3>
              <p>{description}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="about-stats"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="stat-item">
            <div className="stat-value">60+</div>
            <div className="stat-label">Projects Delivered</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">3+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">99%</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
